import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const AboutUs = () => {
    const navigate = useNavigate()
     return (
    <section className="bg-[#f6ae1b] relative ">
      {/* Hero Section */}
      <div className="relative bg-[#311c0e] text-white py-20 px-6 sm:px-16 text-center ">
        <motion.h1
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-4xl sm:text-6xl font-extrabold mt-20" 
        >
          About Dheeram Apparel Creations
        </motion.h1>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.8 }}
          className="mt-4 text-lg sm:text-xl max-w-3xl mx-auto text-[#f6ae1b]"
        >
          Redefining fashion with quality, innovation, and customization — made
          for every business and every customer.
        </motion.p>
      </div>

      
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-10 py-20 px-6 sm:px-16 items-center">
        <motion.img
          src="./aboutbg.jpg"
          alt="About Us"
          className="rounded-2xl shadow-lg"
          initial={{ opacity: 0, x: -60 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        />
        <motion.div
          initial={{ opacity: 0, x: 60 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-3xl font-bold text-[#311c0e] mb-4">
            Who We Are
          </h2>
          <p className="text-[#311c0e] font-medium text-lg mb-4">
            Dheeram Apparel Creations is a trusted e-commerce apparel brand
            specializing in high-quality manufacturing, embroidery,
            sublimation, DTF printing, and custom designs. We empower businesses
            and individuals with innovative clothing solutions that merge style
            with durability.
          </p>
          <p className="text-[#311c0e] font-medium text-lg">
            From startups to global enterprises, we deliver tailored solutions
            that meet diverse needs. Our goal is to make fashion accessible,
            reliable, and sustainable.
          </p>
        </motion.div>
      </div>

      
      <div className="bg-[#311c0e] py-20 px-6 sm:px-16">
        <h2 className="text-3xl font-bold text-center text-white mb-12">
          Why Choose Us?
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10 max-w-6xl mx-auto">
          {[
            {
              title: "Premium Quality",
              desc: "Every product is crafted with attention to detail and durability.",
            },
            {
              title: "Customization",
              desc: "From logos to unique prints, personalize apparel to match your brand.",
            },
            {
              title: "Fast Delivery",
              desc: "Quick turnaround times to ensure your orders are always on schedule.",
            },
            {
              title: "Secure Payments",
              desc: "Safe, encrypted transactions for worry-free shopping.",
            },
            {
              title: "Eco-Friendly",
              desc: "We follow sustainable practices to reduce our environmental impact.",
            },
            {
              title: "Dedicated Support",
              desc: "Our team is here to assist you from inquiry to doorstep delivery.",
            },
          ].map((item, index) => (
            <motion.div
              key={index}
              className="bg-[#f6ae1b] p-6 rounded-2xl shadow-md hover:shadow-xl hover:-translate-y-2 transition-all"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
            >
              <h3 className="text-xl font-bold text-[#311c0e] mb-2">
                {item.title}
              </h3>
              <p className="text-[#311c0e] font-medium">{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>

      
      <div className="max-w-5xl mx-auto text-center py-16 px-6 sm:px-16">
        <motion.h2
          initial={{ opacity: 0, y: -50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-3xl font-bold text-[#311c0e] mb-6"
        >
          Our Vision
        </motion.h2>
        <p className="text-[#311c0e] font-medium text-lg">
          At Dheeram Apparel Creations, our vision is to be a global leader in
          providing reliable, innovative, and cost-effective fashion solutions.
          We aim to transform how businesses and individuals shop for apparel —
          making it smarter, faster, and more personal.
        </p>
      </div>

      
      <div className="bg-[#311c0e] text-center py-14">
        <motion.h3
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
          className="text-2xl sm:text-3xl font-bold text-white mb-6"
        >
          📩 Let’s build something great together <br /><br /> <p className="text-2xl">contact us today <br />to discuss your next project.</p>
        </motion.h3>
        <a
          onClick={() => navigate("/Contact")}
          className="bg-[#f6ae1b] text-[#311c0e] font-bold py-3 px-8 rounded-full shadow-md hover:shadow-xl hover:scale-105 transition-transform duration-300"
        >
          CONTACT US
        </a>
      </div>
    </section>
  );
};

export default AboutUs;
